import {Injectable} from './di';
import {HotelRegion} from './config/hotel-region';

/**
 * Provides hotel basic information including IDs and region
 */
@Injectable()
export class HotelInfoService {
  /**
   * Legacy Hotel ID. Not unique across regions.
   */
  public readonly hotelId: string = window.HOTEL_ID?.toLowerCase()?.trim();

  /**
   * Hotel Global Unique ID.
   */
  public readonly hotelUid: string = window.HOTEL_UID?.toLowerCase()?.trim();

  /**
   * Hotel Region.
   */
  public readonly region: HotelRegion = window.HOTEL_REGION?.toLowerCase()?.trim() as HotelRegion;

  /**
   * List of all possible regions
   */
  private readonly AVAILABLE_REGIONS = ['eu', 'ru', 'cn', 'bn', 'na'];

  constructor() {
    if (!this.hotelId) {
      throw new Error('Hotel ID was not defined!');
    }
    if (!this.hotelUid) {
      throw new Error('Hotel UID was not defined!');
    }
    if (!this.region) {
      throw new Error('Hotel Region was not defined!');
    }
    if (!this.AVAILABLE_REGIONS.includes(this.region)) {
      throw new Error(`Unknown Hotel Region ${this.region}!`);
    }

    window.get_hotelRegion = () => this.region;
    window.get_hotelId = () => this.hotelId;
  }
}

declare global {
  interface Window {
    /**
     * Get hotel region
     * @deprecated
     */
    get_hotelRegion(): HotelRegion;

    /**
     * Get Hotel legacy ID
     * @deprecated
     */
    get_hotelId(): string;
  }

  /**
   * Get hotel region
   * @deprecated
   */
  const get_hotelRegion: () => HotelRegion;

  /**
   * Get Hotel legacy ID
   * @deprecated
   */
  const get_hotelId: () => string;
}
